import React from 'react';
import './BrandLoader.css';

const BrandLoader: React.FC = () => (
  <div className="brand-loader">
    <div className="brand-loader-bg">
      <span className="blob blob-1" />
      <span className="blob blob-2" />
      <span className="blob blob-3" />
    </div>
    <div className="brand-loader-text">Push Notify</div>
  </div>
);

export default BrandLoader;